import * as React from 'react';
import { Router, Route, RouteProps, Redirect } from 'react-router';

export const PrivateRoute = ({ component: Component, ...rest }: any) => (
    <Route {...rest} render={props => (
        localStorage.getItem('SSO-WEB_APPLICATION')
            ?<Component {...props} />
            : <Redirect to={{ pathname: '/v2/auth/signin', state: { from: props.location } }} />
    )} />
)